module.exports = __webpack_public_path__ + "img/pencil.88362c8e.svg";